import Commander from "../Commander";
import Lights from "../Lights";
import {pixiSetTimeout, pixiSetTimeoutAsync} from "../../framework/src/engine/pixi/pixiTimeout";
import Coins from "../Coins";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import events from "../../framework/src/events/EventsObservable";

export default class Counter {
    constructor(wallet, layers, config, audio) {
        this.wallet = wallet;
        this.layers = layers;
        this.layer = this.layers.counter;
        this.config = config;
        this.audio = audio;

        this.solid = Commander.getSprite("solid.png", 640, 360);
        this.solid.alpha = 0;
        this.layer.addChild(this.solid);

        this.coins = new Coins();
        this.coins.create(this.layer, 640,360);
    }

    async bigwin(win) {
        events.dispatch(GAME_EVENTS.GAME_BIGWIN);
        this.audio.fadeInPlaying("bWin", 500);
        this.audio.fadeInPlaying("ui_Counter", 1000, ()=>{}, createjs.Ease.quadIn);
        this.darkenBackground();
        await this.showBigwin();
        this.coins.run();
        this.pulseLights();
        this.runCounter(win);
        this.shineText();
        await this.pulseBigwin();
        this.coins.emitter.emit = false;
        await this.endBigwin();
        this.audio.fadeOutTrack("bWin", 500);
        this.lightenBackground();
        this.reset();
        pixiSetTimeout(1, ()=>{this.coins.emitter.cleanup();})
    }

    create() {
        this.bigwinCounter = new PIXI.Container();
        let shine = Commander.getSprite("shine.png", 0,0);
        shine.scale.set(.99,.99);
        let bg = Commander.getSprite("table.png", 0,0);
        let text = Commander.getSprite("Text_bigwin.png", 0, -70);
        text.scale.set(1.1,1.1);

        this.bigwinCounter.addChild(shine, bg, text);
        this.layer.addChild(this.bigwinCounter);

        this.initLights();

        const style = new PIXI.TextStyle({
            fontFamily : 'Arial',
            fontSize: 102,
            align : 'center',
            fontWeight: 'bold',
            dropShadow: true,
            dropShadowAngle: 0,
            dropShadowBlur: 10,
            dropShadowDistance: 2,
            fill: "white",
            strokeThickness: 2
        });
        this.number = new PIXI.Text('0', style);
        this.number.alpha = 0;
        this.number.position.set(0,40);
        this.number.pivot.x = this.number.width/2;
        this.number.pivot.y = this.number.height/2;
        this.bigwinCounter.addChild(this.number);

        this.numberLength = this.number.text.length;

        this.bigwinCounter.scale.set(0,0);
        this.bigwinCounter.position.set(640,360);
    }

    runCounter(win) {
        this.number.alpha = 1;
        let obj = {n:0};

        Commander.getTween(obj, {n: this.wallet.moneyToCredit(win)}, 5000, () => {
            this.number.text = Math.round(obj.n).toString();
            if (this.number.text.length > this.numberLength) {
                this.number.pivot.x = this.number.width/2;
                this.number.pivot.y = this.number.height/2;
                this.numberLength = this.number.text.length;
            }
        }, () => {
            this.audio.stopTrack("ui_Counter");
            this.audio.playTrack("ui_Counter_Stop");
        });
    }

    async showBigwin() {
        this.bigwinCounter.alpha = 1;
        await Commander.getTweenAsync(this.bigwinCounter.scale, {x: 1.2, y: 1.2}, 500,()=>{},
            createjs.Ease.sineOut);
    }

    shineText() {
        let container = new PIXI.Container();
        let text = Commander.getSprite("Text_bigwin.png", 0, -80);
        let shine = Commander.getSprite("overlay.png", -300, 0);
        text.scale.set(1.2,1.2);
        shine.mask = text;
        container.addChild(text, shine);
        container.position.set(640,360);
        this.layer.addChild(container);
        Commander.getTween(shine, {x: 300}, 500, ()=>{}, ()=>{
            Commander.removeSprite(container);
        });
        Commander.getTween(text.scale, {x: 1, y: 1},500);

    }

    async pulseBigwin() {
        let text = this.bigwinCounter.children[2];
        let brightness = new PIXI.filters.ColorMatrixFilter();
        text.filters = [brightness];
        Commander.getTween(text.scale, {x: 1, y: 1},500);
        await Commander.getTweenAsync(this.bigwinCounter.scale, {x: 1, y: 1},500);
        Commander.getLoop(this.bigwinCounter.scale, {x: 1.1, y: 1.1}, {x: 1, y: 1}, 1000,
            ()=>{}, createjs.Ease.sineInOut);
        Commander.getLoop(text.scale, {x: 1.1, y: 1.1}, {x: 1, y: 1}, 1000,
            ()=>{}, createjs.Ease.sineInOut);
        let obj = {n: 1};
        Commander.getLoop(obj, {n: 1.5}, {n: 1}, 1000, ()=>{
            brightness.brightness(obj.n,false)
        }, createjs.Ease.sineInOut);

        await pixiSetTimeoutAsync(6);
        Commander.cleanArray(text.filters);
        Commander.removeTween(obj);
    }

    async endBigwin() {
        Commander.getTween(this.bigwinCounter, {alpha: 0}, 250, ()=>{},()=>{},createjs.Ease.quadOut);
        await Commander.getTweenAsync(this.bigwinCounter.scale, {x: 6, y: 6}, 500);

    }

    darkenBackground() {
        Commander.getTween(this.solid, {alpha: 1}, 500);
    }

    lightenBackground() {
        Commander.getTween(this.solid, {alpha: 0}, 500);
    }

    reset() {
        Commander.removeTween(this.lights);
        Commander.removeTween(this.bigwinCounter.scale);
        Commander.removeTween(this.bigwinCounter.children[2].scale);
        this.bigwinCounter.scale.set(0,0);
        this.bigwinCounter.children[2].scale.set(1.1,1.1); // text scale
        this.number.text = "0";
        this.number.alpha = 0;
        this.number.pivot.x = this.number.width/2;
        this.number.pivot.y = this.number.height/2;
        this.numberLength = this.number.text.length;
        if (this.tween)
            Commander.removeTween(this.tween);
        this.lights.alpha = 0;
        for (let light of this.lights.children)
            Lights.setLightAlpha(light, .5);
    }

    pulseLights() {
        Commander.getTween(this.lights, {alpha: 1},250, ()=>{}, ()=>{
            this.blinkLights();
        }, createjs.Ease.quadInOut);
    }

    blinkLights() {
        // for (let light of this.lights.children)
        //     Lights.setLightAlpha(light, .5);
        this.lights.alpha = 1;
        this.tween = {n: 0};
        Commander.getLoop(this.tween, {n: .5}, {n: 0}, 420, () => {
            for (let light of this.lightsEven)
                Lights.setLightAlpha(light, .5+this.tween.n);
            for (let light of this.lightsOdd)
                Lights.setLightAlpha(light, 1-this.tween.n);
        }, createjs.Ease.quadOut);
    }

    initLights() {
        let positions = [
            [-160,-182], [0,-182], [160,-182], // top 3
            [319,-6], // right
            [-160,132], [0,132], [160,132], // bottom 3
            [-321,-6], // left
        ];
        this.lights = new PIXI.Container();
        this.lightsOdd = [];
        this.lightsEven = [];
        for (let [key, pos] of positions.entries()) {
            let container = new PIXI.Container();
            let light_layer_1 = this.getLight(pos[0],pos[1],1);
            let light_layer_2 = this.getLight(pos[0],pos[1],2, 0.3);
            let light_layer_3 = this.getLight(pos[0],pos[1],3);

            container.addChild(light_layer_1, light_layer_2, light_layer_3);
            Lights.setLightAlpha(container, .5);
            this.lights.addChild(container);

            if (key % 2)
                this.lightsOdd.push(container);
            else
                this.lightsEven.push(container);
        }
        this.lights.alpha = 0;
        this.bigwinCounter.addChild(this.lights);
    }

    getLight(x, y, layer = 0, alpha = 1) {
        let frame;
        switch(layer) {
            case 0:
                frame = "reels_light_off.png";
                break;
            case 1:
                frame = "reels_light_on_layer1.png";
                break;
            case 2:
                frame = "reels_light_on_layer2_overlay.png";
                break;
            case 3:
                frame = "reels_light_on_layer3.png";
                break;
        }
        let light = Commander.getSprite(frame, x, y);
        light.alpha = alpha;
        light.scale.set(.9,.9);
        return light;
    }
}